import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const IpWarmingList = lazy(() =>
  import("@scenes/IpWarming/IpWarmingList").then((module) => ({
    default: module.IpWarmingList,
  }))
);

export const ipWarmingNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("ip-warming-nro-heading", "Automated IP Warming"),
  pageNameForTracking: () => "Automated IP Warming",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("automated_ip_warming") && featureOn("multiple_ip_warming_plans");
  },
  // The legacy engagement NRO is the searchable "Automated IP Warming" entry until it is
  // fully deprecated; flip searchability to this NRO as part of that cleanup.
  showInSearchResults: false,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  Component: IpWarmingList,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  defaultRoute: "/app_settings/app_settings/email_settings/ip_warming/:appGroupId",
};
